(function () {
  function stripLastCount(text) {
    // remove apenas a ÚLTIMA contagem "(19)" no fim
    return (text || "").replace(/\(\s*\d+\s*\)\s*$/, "").trimEnd();
  }

  function removeCountsFromSizeLabels(root = document) {
    // só mexemos no facet de size taxonomy (para não estragar outros filtros)
    const labels = root.querySelectorAll('label[for][for*="filter.v.t.shopify.size"]');

    labels.forEach((label) => {
      const before = label.textContent || "";
      const after = stripLastCount(before);

      if (after !== before) label.textContent = after;
    });
  }

  function runSoon() {
    requestAnimationFrame(() => requestAnimationFrame(() => removeCountsFromSizeLabels(document)));
  }

  document.addEventListener("DOMContentLoaded", runSoon);
  window.addEventListener("load", runSoon);

  // Prestige re-render via AJAX — reaplica sempre
  const obs = new MutationObserver(runSoon);
  obs.observe(document.body, { childList: true, subtree: true });
})();